module.exports = __webpack_public_path__ + "img/cashcards.2be8a0fb.svg";